export const cardVerificationStatus = {
  cardVerificationRequestStatusAccepted: () => 'CLIENT_PURSE_STATUS_VERIFIED',
  cardVerificationRequestStatusRejected: () => 'CLIENT_PURSE_STATUS_REJECTED',
}
export const cardVerificationType = {
  cardVerificationRequestTypeCardVerification: () => 'cardVerification',
  cardVerificationRequestTypeProfileChange: () => 'profile_change',
  cardVerificationRequestTypeUpdatingDocument: () => 'updating_document',
}

export const colorCardVerificationStatus = function (status: string) {
  switch (status) {
    case 'CLIENT_PURSE_STATUS_INVALID': {
      return '#880a38'
    }
    case 'CLIENT_PURSE_STATUS_UNVERIFIED': {
      return '#5c0011'
    }
    case 'CLIENT_PURSE_STATUS_PENDING': {
      return '#69b1ff'
    }
    case 'CLIENT_PURSE_STATUS_REJECTED': {
      return '#e55353'
    }
    case 'CLIENT_PURSE_STATUS_VERIFIED': {
      return '#2eb85c'
    }
    default:
      return '#d4b106'
  }
}
